import React, { useEffect, useState, useContext } from 'react';
import useKrpano from 'react-krpano-hooks';
import { useSearchParams } from "react-router-dom"

import { programmeNameContext, programmeContext, languageContext, state } from '../../../contexts';

const Pano3D = ({currentInt, room, setVimCurrentFloor, setDirection, fromPano}) => { // Partie krPano

    // /////////////////////////////
    // Properties
    const programmeName = useContext(programmeNameContext)
    const lang = useContext(languageContext)
    // const [canUseGyro, setCanUseGyro] = useState(false)
    const programmeDatas = useContext(programmeContext)
    const [viewNameFromPano, setViewNameFromPano] = useState(null)
    const interieursDatas = programmeDatas.pagesDetails.interieurs2
    const currentLotDatas = interieursDatas.pano.find(x => x.texts[lang] == currentInt)
    const [searchParams, setSearchParams] = useSearchParams();
    

    const { containerRef, krpanoState, callKrpano } = useKrpano({ // KRPano
        scriptPath: `${state === "local" ? "http://moteur-v6" : ""}/public/sources/krPanoBuilder/viewer/krpano.js`,
        embeddingParams: {
            swf: `${state === "local" ? "http://moteur-v6" : ""}/public/programmes/${programmeName}/interieurs2/${currentLotDatas.id}/tour.swf`,
            xml: `${state === "local" ? "http://moteur-v6" : ""}/public/programmes/${programmeName}/interieurs2/${currentLotDatas.id}/tour.xml`,
            target: 'react-krpano',
            html: 'prefer'
        },
        width: "calc(100% - 100px)"
    })
    const [hotspots, setHotspots] = useState([])


    const setPois = (scene) => {


        for (let spot of hotspots) {
            callKrpano(`removehotspot(${spot});`);
        }
        setHotspots([]);

        setTimeout(() => {

            // force la creation du poi floorspot
            callKrpano(`addhotspot(floorspot);`);


            for (const poi of scene.pois) {

                callKrpano(`addhotspot(poi_${poi.id}${poi.dontMove ? "_dontmove" : ""});`);
                callKrpano(`hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].loadstyle(arrowspot);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].url, /public/sources/krPanoBuilder/templates/xml/skin/vtourskin_hotspot.png);`);

                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].scale, 0.2);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].rotate, 0);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].tx, ${poi.position[0]});`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].ty, ${scene.position[1] + 130 - poi.offset});`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].tz, ${poi.position[1]});`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].linkedscene, scene_${poi.link[0].split("-")[1]}-main);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].rx, -90);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].oversampling, 2);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].mipmapping, true);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].zorder, 1);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].distorted, true);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].depth, 0);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].depthbuffer, true);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].torigin, world);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].rotationorder, xyz);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].capture, false);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].handcursor, false);`);
                callKrpano(`set(hotspot[poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}].autoalpha, true);`);

                // Ajout du hotspot en memoire
                setHotspots(old => [...old, `poi_${poi.id}${poi.dontMove ? "_dontmove" : ""}`])

                if (poi.displayLine) {
                    callKrpano(`addhotspot(poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""});`);
                    callKrpano(`hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].loadstyle(skin_bar_large);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].tx, ${poi.position[0]});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].ty, ${scene.position[1] + 130 - poi.offset});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].tz, ${poi.position[1]});`);      
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].width, ${1});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].height, ${poi.height});`);   
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].x, ${0});`);   
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].y, ${0});`);   
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].depth, 0);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].zoom,false);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].bgcolor, 0x${"ffffff"});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}].linkedscene, scene_${poi.link[0].split("-")[1]}-main);`);

                    // Ajout du hotspot en memoire
                    setHotspots(old => [...old, `poi_${poi.id}_bar${poi.dontMove ? "_dontmove" : ""}`])
                }

                if (poi.displayText) {
                    callKrpano(`addhotspot(poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""});`);
                    callKrpano(`hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].loadstyle(skin-direction-text);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].tx, ${poi.position[0]});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].ty, ${scene.position[1] + 130 - poi.offset});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].tz, ${poi.position[1]});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].zoom,false);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].height, ${20 + poi.textScale * 40 + poi.height * 2.0});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].x, ${0});`);     
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].textalign, centerTop);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].bg, false);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].html, ${poi.text[lang]});`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].distorted, false);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].depth, 0);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].linkedscene, scene_${poi.link[0].split("-")[1]}-main);`);
                    callKrpano(`set(hotspot[poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}].css, "overflow : visible; color: white; font-size: ${poi.textScale * 20}px; font-family: BarlowCondensed-Regular; width:auto; border-radius:4px; pointer-events:none!important; ";`);

                    // Ajout du hotspot en memoire
                    setHotspots(old => [...old, `poi_${poi.id}_txt${poi.dontMove ? "_dontmove" : ""}`])
                }

            }

        }, 1800)
    }

    useEffect(() => {
        window.reactAction = (where) => {
            setViewNameFromPano(where)
        }
    }, [])

    useEffect(() => {
        if (viewNameFromPano) {
            // tentative de recuperation de la scene
            let currentKr = null
            for (const room of currentLotDatas.pieces) {
                for (const view of room.views) {
                    if (viewNameFromPano.includes(view.id)) {
                        currentKr = view
                        setPois(view)
                        setVimCurrentFloor(view.floor)
                        fromPano.current = true
                        searchParams.set("piece", room.title[lang]);
                        setSearchParams(searchParams);
                        break
                    }
                }
            }
        }
    }, [viewNameFromPano])

    useEffect(() => {
        if (!currentLotDatas) {return}

        if (room) {
            let name = `scene_${room.views[0].id}-main`
            if (!fromPano.current === true) {
                fromPano.current = false
                callKrpano(`loadscene('${name}', null, MERGE, BLEND(0.4));`)
            } else {
                fromPano.current = false
            }
        }
    }, [krpanoState.isEmbedded, currentLotDatas, room])

    useEffect(() => { // Gestion de la direction de la puce minimap en live

        let int;
        if (krpanoState.isEmbedded) {
            int = setInterval(() => {
                const kr = containerRef.current.children[0];
                if (kr) {
                    const hlookat = kr.get("view.hlookat")
                    const camroll = kr.get("view.camroll")
                    setDirection(camroll + hlookat)
                }
    
            }, 100)
        }
        return () => clearInterval(int)
    }, [krpanoState.isEmbedded])


    // /////////////////////////////
    // Render
    return (
        <div id='pano'>
            <div ref={containerRef} style={{ position: 'relative', width: '100%!important', height: '100%' }} />
        </div>
    )
}

export default Pano3D;